import { render } from "./ShopOrders.vue?vue&type=template&id=a09fce70&scoped=true"
import script from "./ShopOrders.vue?vue&type=script&lang=ts"
export * from "./ShopOrders.vue?vue&type=script&lang=ts"

import "./ShopOrders.vue?vue&type=style&index=0&id=a09fce70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a09fce70"

export default script